import axiosInstance from "../../../lib/axios"; 

// property drp
export async function getProperty(payload){
    try{
        return await axiosInstance.post('PropertyMst/GetPropertyMstUserwisedrp',payload)
    }catch(error){
        return error;
    }
}
//Rise Ticket Api
export async function getwardendrp(payload){
    try{
        return await axiosInstance.post('TrnTicketing/getPropertyWisedrp',payload)
    }catch(error){
        return error;
    }
}
export async function getCategorydrp(payload){
    try{
        return await axiosInstance.post('TrnTicketing/getPropertyWisedrp',payload)
    }catch(error){
        return error;
    }
}
export async function getsubCategorydrp(payload){
    try{
        return await axiosInstance.post('TktSubCategory/getTktSubCategorydrp',payload)
    }catch(error){
        return error;
    }
}
export async function getservicedrp(payload){
    try{
        return await axiosInstance.post('TktSubCategory/getTktSubCatdrp',payload)
    }catch(error){
        return error;
    }
}

export async function getserviceProvider(payload){
    try{
        return await axiosInstance.post('TktSubCategory/getTktSubCatdrp',payload)
    }catch(error){
        return error;
    }
}
export async function getAmenitydrp(payload){
    try{
        return await axiosInstance.post('TrnTicketing/getPropertyWisedrp',payload)
    }catch(error){
        return error;
    }
}


export async function getBed(payload){
    try{
        return await axiosInstance.post('TrnTicketing/getPropertyWisedrp',payload)
    }catch(error){
        return error;
    }
}

export async function getFloor(payload){
    try{
     return await axiosInstance.post('TrnTicketing/getPropertyWisedrp',payload)
    }catch(error){
        return error;
    }
}

export async function insertRiseTicket(payload){
    try{
        return await axiosInstance.post('TrnTicketing/InsertTicket',payload)
    }catch(error){
        return error;
    }
}

//track ticket
export async function GetTrakTicketData(payload){
    try{
        return await axiosInstance.post('TrnTicketing/GetTrnTicketDashBoard',payload)
    }catch(error){
        return error;
    }
}
